import { OrthoJob } from "@nova/protobuf"
import { entityValidator, enumValidator, extraFeaturesValidator, UnionToTuple } from "../util"
import { JobStatusType, OrthoProcessingMode } from "@nova/constants"
import { dateAsNumber } from "../../util"

export const createOrthoJobValidator = entityValidator(OrthoJob, {
    processingMode: {
        validators: enumValidator("processingMode", OrthoProcessingMode),
        nonNull: true,
    },
})
export const updateOrthoJobValidator = entityValidator(OrthoJob, {
    extraFeatures: {
        validators: extraFeaturesValidator,
    },
    status: {
        validators: enumValidator("status", JobStatusType),
        nonNull: true,
    },
    maxZoom: {
        validators: [
            {
                validator: (maxZoom) => maxZoom > 0 && maxZoom < 26,
                error: "Max zoom is out of range",
            },
        ],
        nonNull: true,
    },
})

export const getDefaultOrthoJobCreateArgs = () => ({
    createdAt: dateAsNumber(),
    status: JobStatusType.QUEUED,
    scanArea: [],
})

export type CreateOrthoJobArgs = UnionToTuple<keyof typeof createOrthoJobValidator>
export type UpdateOrthoJobArgs = UnionToTuple<keyof typeof updateOrthoJobValidator>
